import '../styles/application.scss';
import '../styles/login.scss';
import '../login/login.defs.json';

if(process.env.NODE_ENV === 'staging') {
  require.context('../staging-images', true);
} else {
  require.context('../local-prod-images', true);
}
